import {
  GKTextArea,
  GKTextField,
  Grid2,
  Typography,
  UploadIcon,
} from "components";
import GKImageUploader from "components/GKImageUploader";
import { isEmpty } from "lodash";
import { Controller, useFormContext } from "react-hook-form";
import { useUpdateMyWebsiteDetailsMutation } from "store/features/MyWebsite";
import {
  setCroppedQuoteImage,
  setFocusedField,
  setSelectedQuoteImage,
} from "store/slices/MyWebsiteSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { WebsiteDetails } from "./types";

const QuoteForm = () => {
  const dispatch = useAppDispatch();

  const id = useAppSelector((state) => state?.user?.userData?.companyId);
  const { croppedQuoteImage, selectedQuoteImage } = useAppSelector(
    (state) => state?.myWebsite,
  );

  const form = useFormContext<WebsiteDetails>();

  const [updateMyWebsiteDetails] = useUpdateMyWebsiteDetailsMutation();

  const handleFocus = (name: string) => dispatch(setFocusedField(name));

  const handleSetSelectedImage = (img: string | null | undefined) => {
    dispatch(setSelectedQuoteImage(img));
  };

  const handleSetCroppedImage = (img: string | null | undefined) => {
    dispatch(setCroppedQuoteImage(img));
  };

  const handleDeleteImage = async () => {
    if (isEmpty(form.getValues("websiteSection.quotes.quoteOwnerUrl"))) {
      dispatch(setSelectedQuoteImage(null));
      dispatch(setCroppedQuoteImage(null));
      return;
    }

    try {
      await updateMyWebsiteDetails({
        id,
        body: new FormData(),
        path: "quotes",
        isDelete: true,
        field: "quoteOwnerUrl",
      }).unwrap();
    } catch (err) {
      console.error("Update my website details failed:", err);
    }
  };

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12}>
        <Controller
          name="websiteSection.quotes.quotes"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter your quote" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextArea
              {...field}
              inputLabel="Add your own quote or mantra"
              requiredField
              rows={4}
              error={!!error}
              helperText={error?.message}
              onFocus={() => handleFocus(field.name)}
              onBlur={() => handleFocus(null)}
            />
          )}
        />
      </Grid2>
      <Grid2 size={12} container spacing={1}>
        <Grid2 size={12}>
          <Typography fontSize={13} fontWeight={500} color="var(--grey-900)">
            Upload your Image
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name="websiteSection.quotes.quoteOwnerUrl"
            control={form.control}
            render={() => (
              <GKImageUploader
                croppedImage={croppedQuoteImage}
                setCroppedImage={handleSetCroppedImage}
                selectedImage={selectedQuoteImage}
                setSelectedImage={handleSetSelectedImage}
                handleProfilePicDelete={() => handleDeleteImage()}
                form={form}
                logoName={"websiteSection.quotes.quoteOwnerUrl"}
                buttonName="Upload Image"
                startIcon={<UploadIcon />}
                btnVariant="outlined"
              />
            )}
          />
        </Grid2>
      </Grid2>
      <Grid2 size={12}>
        <Controller
          name="websiteSection.quotes.quoteOwnerName"
          control={form.control}
          rules={{
            required: { value: true, message: "Please enter your full name" },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="Your Full Name*"
              requiredField
              error={!!error}
              helperText={error?.message}
              onFocus={() => handleFocus(field.name)}
              onBlur={() => handleFocus(null)}
            />
          )}
        />
      </Grid2>
      <Grid2 size={12}>
        <Controller
          name="websiteSection.quotes.quoteOwnerDesignation"
          control={form.control}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              inputLabel="About Author"
              error={!!error}
              helperText={error?.message}
              onFocus={() => handleFocus(field.name)}
              onBlur={() => handleFocus(null)}
            />
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default QuoteForm;
